module.exports = __webpack_public_path__ + "static/media/FrontPorch.90c005b2.glb";